import React, { useState, useContext, createContext } from 'react'
import { prepareApiRequest, withResponseHandling } from './utils'
import PropTypes from 'prop-types'

const createRatingApiClient = ({ apiUrl, apiToken }) => {
  return {
    // TODO: currently only supports sprachreisen
    // https://github.com/austauschkompass/organisation_component/issues/24
    fetchRatingSummaries: async ({ businessArea }) => {
      let req

      switch (businessArea) {
        case 'sprachreisen':
          req = prepareApiRequest({
            apiUrl,
            apiToken,
            endpoint: `/public/v1/area/${businessArea}/summaries`,
          })
          break
        case 'schueleraustausch':
          req = prepareApiRequest({
            apiUrl,
            apiToken,
            endpoint: `/api/v2/rating_stats`,
          })
          break
        default:
          throw new Error(`ERROR Unknown business area in RatingApi call: ${businessArea}`)
      }

      const { url, headers } = req

      const res = await fetch(url, {
        headers
      })

      return withResponseHandling(res)
    },
  }
}

const RatingApiContext = createContext({})

const RatingApiContextProvider = ({ client: initialClient, children }) => {
  const [client, setClient] = useState(initialClient)
  return (
    <RatingApiContext.Provider value={{ client, setClient }}>
      {children}
    </RatingApiContext.Provider>
  )
}

RatingApiContextProvider.propTypes = {
  client: PropTypes.object,
  children: PropTypes.any
}

const useRatingApiClient = () => {
  const { client } = useContext(RatingApiContext)

  if (!client) {
    throw(`Missing Rating API client, did you forget to wrap your components in RatingApiContextProvider?`)
  }

  return client
}

export {
  RatingApiContext,
  RatingApiContextProvider,
  useRatingApiClient,
  createRatingApiClient,
}
